import OnSaleInvestment from './OnSaleInvestment';
import OnSaleInvestments from './OnSaleInvestments';
import OnSaleInvestmentsAPI from './OnSaleInvestmentsAPI';
import OnSaleInvestmentsError from './OnSaleInvestmentsError';
export default OnSaleInvestmentsAPI;
export { OnSaleInvestment, OnSaleInvestments, OnSaleInvestmentsError };
